module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "confirmation"
    }
  }, [(_vm.confirmation) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "body text-big text-center"
  }, [_vm._v("\n        Your reservation has been submitted."), _c('br'), _c('br'), _vm._v("\n\n        You will receive an email and a text with your reservation details "), (_vm.confirmation.email) ? _c('span', [_vm._v("at " + _vm._s(_vm.confirmation.email))]) : _vm._e(), _vm._v("."), _c('br'), _c('br')])]), _c('br'), _vm._v(" "), _vm._m(0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row no-print"
  }, [_c('div', {
    staticClass: "col-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary mt-5",
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Done")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a8a446e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/reservation/success.vue
// module id = 608
// module chunks = 2